import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import noop from '@anm/helpers/noop';
import React, { useEffect, FC } from 'react';

import { VideoData, VideoPlayerCallbacks } from '../../types';
import Loader from '../Loader';
import Logo from '../Logo';

import { Wrapper } from './Wrapper';

type VideoInProcessProps = {
  videoData: VideoData;
  playerWidth: number;
} & VideoPlayerCallbacks;

const VideoInProcess: FC<VideoInProcessProps> = ({
  playerWidth,
  videoData: { sizes, poster, configs },
  onInit = noop
}) => {
  useEffect(() => {
    onInit();
  }, []);

  const ratio = sizes.width / sizes.height;
  const wrapperHeight = Math.round(playerWidth / ratio);

  return (
    <Wrapper preview={poster.posterUrl} {...{ wrapperHeight }}>
      <Logo />
      <Loader color={configs.playerColor || DEFAULT_WAVE_COLOR} message="Video is processing" transparent={false} />
    </Wrapper>
  );
};

export default VideoInProcess;
